import ErrorPage from 'ContentEditorUI/components/app/ErrorPage';
import { APP_ERRORS } from 'ContentEditorUI/lib/app/constants';
import { useUpgradePoint } from 'ui-addon-upgrades/ums/useUpgradePoint';
import { jsx as _jsx } from "react/jsx-runtime";
export default function NeedsUpgradePage({
  upgradeSource
}) {
  const {
    openUpgradePage
  } = useUpgradePoint(upgradeSource);
  return /*#__PURE__*/_jsx(ErrorPage, {
    appErrorCategory: APP_ERRORS.NEEDS_UPGRADE,
    onUpgrade: openUpgradePage
  });
}